export default __webpack_public_path__ + "static/media/pelvic-leak.a7b0d91c.png";